var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 141,
    viewBox: "0 0 133 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5829 74.5147C70.7156 76.0111 67.9377 76.8306 66.4979 74.5147C64.9415 72.4689 66.0858 67.7182 70.5829 66.3467C74.8186 64.723 81.5209 67.8399 82.8382 74.5147C84.5165 80.9328 79.4484 89.5911 70.5829 90.8516C61.9929 92.5863 51.3483 85.5612 50.1575 74.5147C48.3526 63.7377 57.3631 51.1459 70.5829 50.0098C83.5463 48.1507 98.0997 59.1064 99.1785 74.5147C101.098 89.6533 88.1761 106.177 70.5829 107.188C53.2495 109.172 34.7745 94.2823 33.8174 74.5147C31.7787 55.0042 48.6197 34.5704 70.5829 33.6733C92.2691 31.578 114.689 50.3752 115.519 74.5147C117.682 98.3845 96.9067 122.752 70.5829 123.524C44.524 125.745 18.1929 103.016 17.4771 74.5147C15.2024 46.2837 39.8869 17.9875 70.5829 17.3366C101.005 14.9925 131.268 41.6548 131.859 74.5147C134.261 107.118 105.639 139.324 70.5829 139.861C35.8015 142.32 1.6036 111.746 1.13676 74.5147C-1.37912 37.5525 31.1588 1.41229 70.5829 1H90.5728",
    stroke: "url(#paint0_linear_7_145)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_145",
    x1: 66.5,
    y1: 1,
    x2: 66.5,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFEEE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiral);
export default __webpack_public_path__ + "static/media/Spiral.01addc148ed525400146f0493162ea1a.svg";
export { ForwardRef as ReactComponent };